import { COMPANY_DETAILS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminCompanyDetailsService = {
  getAll: () => requests.get(`${COMPANY_DETAILS_URL}`),
  create: (params: any) => requests.post(`${COMPANY_DETAILS_URL}`, params,true),
};
